import { has, some } from 'lodash'
import React, { useMemo } from 'react'
import { useFormState } from 'react-final-form'

import Icon from '../Icon'

type TInlineEditorValidationProps = {
  fieldPaths: string[]
}

const InlineEditorValidation = (
  props: TInlineEditorValidationProps,
): React.ReactElement => {
  const { fieldPaths } = props

  const formState = useFormState({ subscription: { errors: true } })

  const hasError = useMemo(() => {
    if (some(fieldPaths, (fieldPath) => has(formState.errors, fieldPath))) {
      return true
    }
    return false
  }, [formState])

  return hasError ? (
    <div className="text-danger">
      <Icon icon="fas fa-exclamation-triangle" />{' '}
      {i18n.t(
        'inline_editor_validation_please_check_fields',
        'Bitte Felder überprüfen',
      )}
    </div>
  ) : (
    <></>
  )
}

export default InlineEditorValidation
